import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class KeepAliveService {
    constructor(private apiService: ApiService) {}

    doRequest(): void {
        this.apiService.get('keepalive/get', { t: Date.now() });
    }
}
